import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { Button, buttonVariants } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { imageUrl } from '../../../../helpers'
import DiscordBotInstructions from '../../../TeamDashboard/components/DiscordBotInstructions'
import Callout from './Callout'

const DiscordCallout = () => {
  const { t } = useTranslation()
  const [viewingInstructions, setViewingInstructions] = useState(false)

  return (
    <>
      <Callout
        logoSrc={imageUrl('discord-logo-blue.svg')}
        title={t('homepage.discord-title')}
        description={t('homepage.discord-description')}
      >
        <a
          href='/get_discord_bot'
          target='_blank'
          rel='noopener noreferrer'
          className={cn(buttonVariants({ variant: 'outline' }), 'gap-2')}
        >
          {t('homepage.discord-link')}
          <ArrowRight className='h-4 w-4' />
        </a>
        <Button
          type='button'
          variant='ghost'
          onClick={() => setViewingInstructions(true)}
        >
          {t('homepage.discord-instructions')}
        </Button>
      </Callout>
      <DiscordBotInstructions
        open={viewingInstructions}
        setOpen={setViewingInstructions}
      />
    </>
  )
}

export default DiscordCallout
